<template>
  <div class="d-flex w-100">
    <div class="pr-1 flex-1">
      <slot />
    </div>
    <div class="description-long pl-1 small text-muted flex-1 mt-4 pt-1" v-html="descriptionLong" />
  </div>
</template>

<script>
export default {
  name: 'WithDescriptionLong',
  inheritAttrs: false,
  props: {
    descriptionLong: {
      type: String,
      default: '',
    },
  },
}
</script>

<style>
/*
 * This is copied from PageEditor component styling, with some slight changes.
 * Didn't want to make them shared, as conceptually these are different
 * and might need separate changes at some point.
 */
.description-long {
  word-wrap: break-word;
}
.description-long * {
  caret-color: currentColor;
}
.description-long *:focus {
  outline: none;
}
.description-long pre {
  padding: 0.7rem 1rem;
  border-radius: 5px;
  background: #000000;
  color: #ffffff;
  font-size: 0.8rem;
  overflow-x: auto;
}
.description-long pre code {
  display: block;
}
.description-long p code {
  display: inline-block;
  padding: 0 0.4rem;
  border-radius: 5px;
  font-size: 0.8rem;
  font-weight: bold;
  background: rgba(0, 0, 0, 0.1);
  color: rgba(0, 0, 0, 0.8);
}
.description-long ul,
.description-long ol {
  padding-left: 1rem;
}
.description-long li > p,
.description-long li > ol,
.description-long li > ul {
  margin: 0;
}
.description-long a {
  color: var(--blue);
  cursor: pointer;
}
.description-long a:hover {
  text-decoration: underline;
}
.description-long blockquote {
  border-left: 3px solid rgba(0, 0, 0, 0.1);
  padding-left: 0.8rem;
  font-style: italic;
}
.description-long blockquote p {
  margin: 0;
}
.description-long img {
  max-width: 100%;
  border-radius: 3px;
}

.description-long table tr {
  border-bottom: 1px solid #dae1e7;
}

.description-long table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  margin: 0;
  overflow: hidden;
}
.description-long table td, .description-long table th {
  min-width: 1em;
  padding: 6px 12px;
  vertical-align: top;
  box-sizing: border-box;
  position: relative;
}
.description-long table td > *, .description-long table th > * {
  margin-bottom: 0;
}
.description-long table th {
  font-weight: bold;
  background: #f1f5f8;
  text-transform: uppercase;
  text-align: left;
}
.description-long table .selectedCell:after {
  z-index: 2;
  position: absolute;
  content: "";
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(200, 200, 255, 0.4);
  pointer-events: none;
}
.description-long table .column-resize-handle {
  position: absolute;
  right: -2px;
  top: 0;
  bottom: 0;
  width: 4px;
  z-index: 20;
  background-color: #adf;
  pointer-events: none;
}
.description-long .tableWrapper {
  margin: 1em 0;
  overflow-x: auto;
}
.description-long .resize-cursor {
  cursor: ew-resize;
  cursor: col-resize;
}

.description-long h1 {
  font-size: 1.875rem;
  font-weight: 300;
  margin-bottom: 16px;
}

.description-long h2 {
  font-size: 1.5rem;
  padding-bottom: 8px;
  margin-bottom: 16px;
  border-bottom: 1px solid #dae1e7;
}

.description-long h3 {
  font-size: 1.25rem;
  font-weight: bold;
}
</style>
